import React from 'react';
import { ComponentTitleWrapper } from './styles/pageHeader.style';

export default props => (
  <ComponentTitleWrapper className="isoComponentTitle">
    {props.children}
  </ComponentTitleWrapper>
);


// WEBPACK FOOTER //
// ./src/components/UI/PageHeader.js